// Based on https://github.com/Microsoft/TypeScript/issues/4813
// We import all func in actions to export it after because export * as alias from 'yourfile' give a syntax error
import * as routesActions from './actions';
import * as routesSelectors from './selectors';
import routesReducer from './reducer';
export { routesActions };
export { routesSelectors };
export default routesReducer;
export { routesSagas } from './sagas';
export { default as routesTypes } from './types';